import { Box, Button, Stack, theme } from '@dtx-company/design-system/src'
import { CreatorOfficeHoursData } from '../types'
import { FC } from 'react'
import { prismicCachedImage } from '@app/prismic/src/utils'
import Image from 'next/image'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

//sectionId is used for navigation
const CreatorOfficeHoursSection: FC<{
  data?: CreatorOfficeHoursData
  sectionId?: string
}> = ({ data, sectionId }) => {
  if (!data) return null
  return (
    <Box
      sx={{
        padding: {
          xs: '33px',
          md: '60px'
        },
        mb: { xs: '32px', md: '56px', lg: '96px' }
      }}
      id={sectionId}
      data-testid={sectionId}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            _: '1f',
            md: '33% auto'
          },
          backgroundColor: theme.palette.info.dark,
          borderRadius: '12px',
          maxWidth: '1033px',
          mx: 'auto',
          py: {
            _: '27px',
            md: '32px'
          },
          px: {
            _: '27px',
            md: '29px'
          }
        }}
      >
        <Box
          sx={{
            gridArea: { xs: '2', md: '1' }
          }}
        >
          {data.primary?.image && (
            <Image
              data-testid={data.primary?.image?.alt}
              src={prismicCachedImage(data.primary.image.url ?? '')}
              width={data.primary.image.dimensions?.width}
              height={data.primary.image.dimensions?.height}
              alt={data.primary?.image?.alt ?? 'Flowcode'}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          )}
        </Box>
        <Stack
          direction="column"
          spacing={theme.spacing(6)}
          sx={{
            ml: {
              xs: '0',
              md: '21px'
            },
            mb: {
              xs: '16px',
              md: '0'
            }
          }}
        >
          <PrismicText
            richTextField={data.primary?.header}
            variant="display/large"
            color="primary.white"
            fontWeight="600"
            fontSize={{ xs: '24px', md: '28px', lg: '32px' }}
            textAlign={{ xs: 'center', md: 'left' }}
            lineHeight={{ xs: '30px', lg: '40px' }}
          />
          {!!data.primary?.description?.length && (
            <PrismicText
              richTextField={data.primary.description}
              variant="body/medium"
              color="primary.white"
              textAlign={{ xs: 'center', md: 'left' }}
              fontSize={{ xs: '14px', md: '16px' }}
              style={{ whiteSpace: 'pre-wrap' }}
            />
          )}
          {!!data.primary?.address?.length && (
            <PrismicText
              richTextField={data.primary.address}
              variant="body/medium"
              color="primary.white"
              textAlign={{ xs: 'center', md: 'left' }}
              fontSize={{ xs: '14px', md: '16px' }}
              style={{ whiteSpace: 'pre-wrap' }}
            />
          )}
          <Stack direction="row">
            <Button
              data-heap-id="CreatorOfficeHoursSection_CTAButton"
              href={data.primary?.button_href?.url}
              color="inherit"
            >
              {data.primary?.button_label}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default CreatorOfficeHoursSection
